import { Button } from "antd";
import FormItemInput from "../form-item/form-item-input";
import type {
  FilterConfirmProps,
  FilterRestProps,
} from "antd/es/table/interface";

export default function FilterSearch({
  clearFilters,
  confirm,
  selectedKeys,
  setSelectedKeys,
}: {
  setSelectedKeys: (selectedKeys: React.Key[]) => void;
  selectedKeys: React.Key[];
  confirm: (param?: FilterConfirmProps | undefined) => void;
  clearFilters: ((param?: FilterRestProps | undefined) => void) | undefined;
}) {
  return (
    <div className="p-4 flex flex-col gap-4">
      <FormItemInput
        inputProps={{
          placeholder: "جستجو...",
          value: selectedKeys?.[0] || "",
          onChange: (e) =>
            setSelectedKeys?.(e.target.value ? [e.target.value] : []),
          onPressEnter: () => confirm?.(),
        }}
      />
      <div className="flex gap-2">
        <Button className="w-1/2" type="primary" onClick={() => confirm?.()}>
          جستجو
        </Button>
        <Button
          className="w-1/2"
          danger
          onClick={() => {
            setSelectedKeys?.([]);
            clearFilters?.();
            confirm?.();
          }}
        >
          پاک کردن
        </Button>
      </div>
    </div>
  );
}
